import {EventPatch} from "../../types/domain.ts";
import {baseRequestService} from "../base.ts";

export const eventsEventIdPatch = (eventId: string, data: EventPatch) => baseRequestService({
    url: `/events/${eventId}`,
    method: 'PATCH',
    data
})